var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { node, bool, oneOf } from 'prop-types';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import slideLeft from './SlideLeftAnimation.scss';
import slideRight from './SlideRightAnimation.scss';

export var SlideDirection = {
  left: 'left',
  right: 'right'
};

var SlideAnimation = function (_Component) {
  _inherits(SlideAnimation, _Component);

  function SlideAnimation() {
    _classCallCheck(this, SlideAnimation);

    return _possibleConstructorReturn(this, (SlideAnimation.__proto__ || Object.getPrototypeOf(SlideAnimation)).apply(this, arguments));
  }

  _createClass(SlideAnimation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animateAppear = _props.animateAppear,
          animateEnter = _props.animateEnter,
          animateLeave = _props.animateLeave,
          children = _props.children,
          direction = _props.direction;

      var animationDuration = 300; // Synced with SlideAnimation.scss file
      var transitionName = direction === SlideDirection.left ? slideLeft : slideRight;
      return React.createElement(
        ReactCSSTransitionGroup,
        {
          transitionAppear: animateAppear,
          transitionLeave: animateLeave,
          transitionAppearTimeout: animateAppear ? animationDuration : 0,
          transitionEnterTimeout: animateEnter ? animationDuration : 0,
          transitionLeaveTimeout: animateLeave ? animationDuration : 0,
          transitionName: transitionName
        },
        children
      );
    }
  }]);

  return SlideAnimation;
}(Component);

SlideAnimation.propTypes = {
  direction: oneOf([SlideDirection.left, SlideDirection.right]),
  animateAppear: bool,
  animateEnter: bool,
  animateLeave: bool,
  children: node
};

SlideAnimation.defaultProps = {
  direction: SlideDirection.left,
  animateAppear: true,
  animateEnter: true,
  animateLeave: true,
  children: null
};

export default SlideAnimation;
//# sourceMappingURL=SlideAnimation.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Animations/SlideAnimation.js